
import { Component, Prop, Vue } from "vue-property-decorator";
import { Project } from "../../entities/Project";
import { ProjectLanguage } from "../../entities/ProjectLanguage";
import { getLanguageLabel } from "../../utils/languageUtils";
import LanguageDropdown from "../../components/LanguageDropdown.vue";
import { toastError } from "../../utils/toast";
import { TRANSLATIONS_EXPORT_API_URL, TRANSLATIONS_EXPORT_API_TOKEN } from "../../utils/constants";

@Component({ components: { LanguageDropdown } })
export default class ExportTab extends Vue {
  @Prop({ required: true }) project!: Project;

  @Prop({ required: true }) languages!: ProjectLanguage[];

  selectedLanguage = "";

  langError = "";

  exporting = false;

  exportError = "";

  get languageItems(): { text: string; value: string }[] {
    return this.languages.map((l) => ({
      text: getLanguageLabel(l.languageCode),
      value: l.languageCode,
    }));
  }

  async runExport() {
    if (!this.selectedLanguage) {
      this.langError = "Please select a language.";
      return;
    }

    this.exporting = true;
    this.exportError = "";

    try {
      const url = `${TRANSLATIONS_EXPORT_API_URL}?project_id=${encodeURIComponent(this.project.id)}&language_code=${encodeURIComponent(
        this.selectedLanguage
      )}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "x-api-token": TRANSLATIONS_EXPORT_API_TOKEN,
        },
      });

      if (!response.ok) {
        const body = await response.json().catch(() => null);
        const message = body?.message || `Export failed (${response.status}).`;
        throw new Error(message);
      }

      const data = await response.json();
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
      const downloadUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = `${this.project.name}_${this.selectedLanguage}.json`;
      a.click();
      URL.revokeObjectURL(downloadUrl);
    } catch (e: any) {
      this.exportError = e.message || "Export failed. Please try again.";
      toastError(this.exportError);
    } finally {
      this.exporting = false;
    }
  }
}
